<template lang="pug">
b-modal(
  ref="stockModal"
  id="stock-validation-modal"
  hide-footer
  centered
  size="md"
  no-close-on-backdrop
  @hidden="$emit('hidden')"
)
  template(#modal-header="{ close }")
    h5.modal-title.font-weight-bold {{ title }}
    b-icon.close-icon(icon="x" @click="close()")

  .modal-body-content.text-center
    .warning-icon-container.mb-4
      b-icon(icon="exclamation-triangle-fill" variant="danger" font-scale="4")
    
    p.warning-text
      | {{ messagePrefix }} 
      strong {{ context }} 
      | {{ messageSuffix }}
      br
      | Los siguientes equipos ya no cuentan con el stock necesario en nuestro inventario para cubrir la solicitud:

    .equipment-error-list.mt-4
      .error-item-card(v-for="item in equipments" :key="item.id")
        .item-image
          img(v-if="item.imagen_url" :src="formatImgUrl(item.imagen_url)")
          b-icon(v-else icon="laptop" font-scale="1.5")
        .item-info.text-left
          p.item-name {{ item.modelo }}
          p.item-price {{ item.precio_tienda | formatCurrency }}

    .actions-row.mt-5.d-flex.justify-content-center.gap-3
      b-button.btn-cancel(@click="$refs.stockModal.hide()") Cancelar
      b-button.btn-edit-ove(@click="goToEdit") Editar Cotización
</template>

<script>
import { backUrl } from '../../../settings'

export default {
  name: 'StockValidationModal',
  props: {
    equipments: {
      type: Array,
      default: () => [],
    },
    oveId: {
      type: [Number, String],
      required: true,
    },
    context: {
      type: String,
      default: 'pagar', // 'pagar' o 'reactivar'
    },
  },
  computed: {
    title() {
      return this.context === 'reactivar'
        ? 'Stock insuficiente para reactivar'
        : 'Stock insuficiente para pagar cotizacion'
    },
    messagePrefix() {
      return 'No es posible'
    },
    messageSuffix() {
      return 'esta cotización.'
    },
  },
  methods: {
    show() {
      this.$refs.stockModal.show()
    },
    hide() {
      this.$refs.stockModal.hide()
    },
    formatImgUrl(url) {
      if (!url) return null
      if (url.startsWith('http')) return url
      return `${backUrl}${url}`
    },
    goToEdit() {
      this.hide()
      this.$router.push(`/oportunidad-venta-equipo/${this.oveId}/editar`)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.modal-title {
  color: #23201c;
  font-size: 18px;
}

.close-icon {
  font-size: 24px;
  cursor: pointer;
  color: #525252;
}

.modal-body-content {
  padding: 10px 20px;
}

.warning-text {
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  color: #525252;
  line-height: 1.4;
}

.equipment-error-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.error-item-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px;
  border: 1px solid #525252;
  border-radius: 8px;
  background: #ffffff;

  .item-image {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .item-info {
    .item-name {
      font-size: 14px;
      color: #525252;
      margin-bottom: 2px;
      font-weight: 500;
    }
    .item-price {
      font-size: 14px;
      color: #1d4ed8;
      font-weight: 700;
      margin: 0;
    }
  }
}

.actions-row {
  gap: 15px;

  .btn-cancel {
    background-color: #f5f6fa;
    border: 1px solid #525252;
    color: #525252;
    border-radius: 8px;
    height: 45px;
    padding: 0 30px;
    font-weight: 600;

    &:hover {
      background-color: darken(#f5f6fa, 5%);
    }
  }

  .btn-edit-ove {
    background-color: $samtek-yellow;
    border: none;
    color: $samtek-black;
    border-radius: 8px;
    height: 45px;
    padding: 0 30px;
    font-weight: 600;

    &:hover {
      background-color: darken($samtek-yellow, 5%);
    }
  }
}

::v-deep .modal-header {
  border-bottom: none;
  padding: 20px 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
